(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_26a4cc1"] && !Shopify.designMode) return;
  try {
    (() => {
    const tagName = 'esm-seasoning-box-builder';
    if (customElements.get(tagName)) return;
    class SeasoningBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.initialized || !this.querySelector("[data-submit]")) return;
        this.initialized = true;
        this.total = 0;
        this.target = 30;
        this.busy = false;
        this.counter = this.querySelector('[data-counter]');
        this.submitButton = this.querySelector('[data-submit]');
        this.message = this.querySelector('[data-message]');
        this.cards = Array.from(this.querySelectorAll('[data-flavor-card]'));
        this.cards.forEach((card) => {
          const output = card.querySelector('[data-quantity]');
          card.querySelector('[data-minus]').addEventListener('click', () => this.change(card, -1));
          card.querySelector('[data-plus]').addEventListener('click', () => this.change(card, 1));
          output.value = '0';
          const names = ['Fuego Plus','Fuego Azul · Blue Heat','Habanero Limón','Salsas Verdes','Queso Fuego','Jalapeño Queso','Mystery · Salsas Negras','Cheddar Cheese','Habanero Miel','Jalapeño','Chile Limón Plus','Elote Enchilado','Adobado'];
          const idx = this.cards.indexOf(card);
          if (this.cards.length === 13) card.querySelector('.ai-esm-seasoning-box-builder__flavor').textContent=names[idx];
        });
        this.submitButton?.addEventListener('click', () => this.addBox());
        this.sizeSelect = this.querySelector('[data-box-size]');
        this.sizeSelect.addEventListener('change', () => this.selectSize());
        const requestedSize = new URLSearchParams(window.location.search).get('box');
        if (requestedSize === '20' || requestedSize === '30') this.sizeSelect.value = requestedSize;
        this.selectSize();
      }
      selectSize() {
        if (this.busy) return;
        this.target = Number(this.sizeSelect.value);
        this.total = 0;
        this.dataset.variantId = this.dataset[this.target === 20 ? 'variant20' : 'variant30'];
        this.dataset.productValid = this.target === 20 ? this.dataset.valid20 : 'true';
        this.cards.forEach(card => { const output=card.querySelector('[data-quantity]'); output.value='0'; output.textContent='0'; card.classList.remove('mx-selected'); card.querySelector('[data-minus]').disabled=true; card.querySelector('[data-plus]').disabled=this.dataset.productValid !== 'true'; });
        this.counter.textContent='0/'+this.target+' LB';
        this.querySelector('[data-progress]').style.width='0%';
        const perPound=this.target===20?'$9.99':'$8.99';
        this.querySelector('.mx-offer strong').textContent=perPound+'/ LB';
        this.querySelector('.mx-badge').textContent=this.target+' LB MIXED BOX';
        this.querySelector('.mx-steps span:nth-child(2)').textContent='2  Fill '+this.target+' LB';
        this.querySelector('.ai-esm-seasoning-box-builder__price').textContent=this.dataset[this.target===20?'price20':'price30']+' ('+perPound+'/LB)';
        this.querySelector('.ai-esm-seasoning-box-builder__shipping').textContent=this.target===20?'20 bags × 1 LB · US shipping $19.99':'30 bags × 1 LB · Shipping calculated at checkout';
        this.submitButton.disabled=true;
        this.message.textContent=this.dataset.productValid==='true'?'':'This box is currently unavailable.';
      }
      change(card, delta) {
        if (this.busy) return;
        const output = card.querySelector('[data-quantity]');
        const next = Number(output.value) + delta;
        if (next < 0 || this.total + delta > this.target) return;
        output.value = String(next);
        output.textContent = String(next);
        this.total += delta;
        card.querySelector('[data-minus]').disabled = next === 0;
        this.counter.textContent = `${this.total}/${this.target} LB selected · ${this.target-this.total} LB remaining`;
        this.querySelector('[data-progress]').style.width = `${this.total/this.target*100}%`;
        card.classList.toggle('mx-selected',next>0);
        this.submitButton.disabled = this.total !== this.target;
        this.cards.forEach(c => c.querySelector('[data-plus]').disabled = this.total >= this.target);
        this.message.textContent = '';
      }
      async addBox() {
        if (this.busy || this.total !== this.target || this.dataset.productValid !== 'true') return;
        this.busy = true;
        this.submitButton.disabled = true;
        this.message.textContent = '';
        const properties = { 'Total weight': this.target+' LB' };
        this.cards.forEach((card) => {
          const quantity = Number(card.querySelector('[data-quantity]').value);
          if (quantity > 0) properties[`${card.dataset.name} (LB)`] = String(quantity);
        });
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1, properties }] })
          });
          if (!response.ok) throw new Error(this.dataset.errorText);
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          this.message.textContent = error.message || this.dataset.errorText;
          this.busy = false;
          this.submitButton.disabled = this.total !== this.target;
        }
      }
    }
    customElements.define(tagName, SeasoningBuilder);
  })();
  } catch(e) { console.error(e); }
})();

})();
